export const i18n = {
	main: {
		gjovikregionen: 'Gjøvikregionen Utvikling',
		sanityStudio: 'Sanity Studio',
	},
	components: {
		articleList: {
			alsoRead: 'Les også',
			seeAll: 'Se alle artikler her',
			seeMore: 'Se mer',
		},
		search: {
			placeholder: 'Søk...',
			placeholderNotFound: 'Skriv hva du så etter...',
			buttonNotFound: 'Søk',
			buttonArticleSearch: 'Søk',
		},
		header: {
			menu: 'Meny',
			skipToMainContent: 'Hopp til hovedinnhold',
		},
		footer: {
			postalAddress: 'Postadresse',
			visitingAddress: 'Besøksadresse',
			phone: 'Telefon',
			email: 'E-post',
			copyright: 'Gjøvikregionen',
			socialMedia: 'Sosiale medier',
		},
		articleSearch: {
			filters: 'Filtrering',
			articleTypes: 'Innholdstype',
			categories: 'Tema',
			published: 'Publisert',
			noResults: 'Ingen treff',
			articles: 'artikler',
		},
		searchPage: {
			results: 'Søkeresultater',
			yourSearch: 'Ditt søk ga',
			viewing: 'Viser',
			of: 'av',
			hits: 'treff.',
			noResults: 'Ingen treff',
			articleTypes: 'Innholdstype',
			published: 'Publisert',
		},
		newsletter: {
			signupSuccessful: 'Takk for din påmelding!',
			signupError:
				'Vi klarte dessverre ikke melde deg på nyhetsbrevet. Vennligst sjekk at informasjonen du fylte ut er korrekt og prøv igjen.',
			alreadySignedUp: 'Du er allerede påmeldt dette nyhetsbrevet.',
		},
	},
	preview: {
		active: 'Forhåndsvisningsmodus aktiv.',
		activeDescription: 'Du kan nå se upublisert innhold.',
		exit: 'Avslutt forhåndsvisningsmodus',
	},
} as const;
